module.exports = __webpack_public_path__ + "img/Certificate_13.08251539.jpg";